import type { AnchorLink } from '~/types/ui';

export type UseAnchors = {
  anchors: ComputedRef<AnchorLink[]>;
  setAnchor: (anchor: AnchorLink) => void;
  removeAnchor: (id: string) => void;
  offset: Ref<number>;
  getAnchorFromRoute: () => AnchorLink | null;
};

export const INJECT_ANCHORS = Symbol('anchors') as InjectionKey<UseAnchors>;

export const useAnchors = (offset: Ref<number>): UseAnchors => {
  const _anchors: Ref<AnchorLink[]> = ref<AnchorLink[]>();

  _anchors.value = [];

  const route = useRoute();

  const setAnchor = (anchor: AnchorLink) => {
    const index = _anchors.value.findIndex((anc) => anc.id === anchor.id);
    if (index === -1) {
      _anchors.value.push(anchor);
    } else {
      _anchors.value[index] = anchor;
    }
  };

  const removeAnchor = (id) => {
    const index = _anchors.value.findIndex((anc) => anc.id === id);
    if (index > -1) {
      _anchors.value.splice(index, 1);
    }
  };

  const anchors = computed(() => {
    return _anchors.value.sort((a, b) => {
      return (
        toRef(a.position).value -
        window.screenTop -
        (toRef(b.position).value - window.screenTop)
      );
    });
  });

  const scrollToPosition = (position, behavior: ScrollBehavior) => {
    const scollY = position - offset.value - 10; // 10 is arbitrary
    window.scrollTo({
      top: scollY,
      behavior,
    });
  };

  const getAnchorFromRoute = () => {
    const id = route.hash.replace('#', '');
    const anchor = anchors.value.find((anchor) => anchor.id === id);
    return anchor;
  };

  return {
    setAnchor,
    anchors,
    removeAnchor,
    offset,
    getAnchorFromRoute,
  };
};
